<template>
    <div class="scrollable-container">
        <div>
	   <div class="ml-7" v-if="categoryId == 2 &&!hideSubscribedCheckbox"><v-checkbox v-model="isSubcribed" :label="$t('res_Label_Subscribed_Entities')" solo></v-checkbox></div>
            <div class="search-bar-gray d-flex">
                <v-btn @click="handleSearch()"><v-icon>mdi-magnify</v-icon></v-btn>
                <v-text-field v-model="searchVal" solo :label="SearchLabel" @keydown.enter="searchFieldKeydownHandler"></v-text-field>
                <div class="custom-icon-wrapper" v-if="searchVal != ''">
                    <v-icon @click="clear()">custom-icon mdi-close</v-icon>
                </div>
            </div>
            <v-treeview class="mt-4" ref="searchTree" dense :items="items" :load-children="buildChildTree" :open="openNodes" @click:open="$event.stopPropagation()"
                @update:open="handleCollapseChildren" open-on-click activatable>
                <template v-slot:label="{ item }">
                    <div class="d-flex align-items-center">
                        <div class="d-flex align-items-center v-treeview-leaf-icons" v-if="item.isUser" @click.stop>
                            <v-checkbox v-if="singleValue == false"
                                :input-value="isItemSelected(item)"
                                @change="toggleItemSelection(item, $event)"
                                dense>
                            </v-checkbox>
                            <v-checkbox v-else
                                :input-value="isSingleItemSelected(item)"
                                @change="setSingleItemSelection(item, $event)"
                                dense>
                            </v-checkbox>
                            <v-icon class="ml-2" :color="item.color">mdi-account</v-icon>
                        </div>
                        <div v-if="!item.isUser && allowStructureSelect" @click.stop>
                            <v-checkbox v-if="singleValue == false"
                                :input-value="isItemSelected(item)"
                                @change="toggleItemSelection(item, $event)"
                                dense>
                            </v-checkbox>
                            <v-checkbox v-if="singleValue == true"
                                :input-value="isSingleItemSelected(item)"
                                @change="setSingleItemSelection(item, $event)"
                                dense>
                            </v-checkbox>
                        </div>
                        <div v-if="!item.isUser">
                            <span v-if="item.childrens !== 0 && !item.isEntityRecipient"
                                class="v-treeview-node__inner-label"
                                :style="{color: (item.isEntityRecipient) ? '#78cc8b' : '#455664'}">
                                {{ lang == 'en' ? item.name : (item.nameAr != null ? item.nameAr : item.name) }}
                            </span>
                            <span v-if="item.childrens === 0 || item.isEntityRecipient"
                                class="v-treeview-node__inner-label v-treeview-leaf"
                                :style="{color: (item.isEntityRecipient) ? '#78cc8b' : '#455664'}">
                                {{ lang == 'en' ? item.name : (item.nameAr != null ? item.nameAr : item.name ) }}
                            </span>
                        </div>
                        <div v-if="item.isUser" class="w-100">
                            <div class="d-flex justify-content-between w-100 v-treeview-node__inner-label v-treeview-leaf">
                                <div class="user-name w-70">
                                    {{ item.name }}
                                </div>
                                <div class="light-gray w-30" v-tooltip="item.profession">
                                    <span class="text-limit one-line">
                                        {{ item.profession }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </v-treeview>
            <div class="dialog-footer d-flex align-items-center justify-content-end gap-3">
                <v-btn color="light-blue" @click="closeAddressBook()">{{ $t("res_ButtonText_Cancel") }}</v-btn>
                <v-btn :disabled="AddDisabled" color="primary" @click="handleSelectFromAddressBook">{{ $t("res_ButtonText_Add") }}</v-btn>
            </div>
        </div>
    </div>
</template>
 
<script>
import axios from 'axios';
import constants from '@/assets/js/constants'
import * as utils from '@/assets/js/common.js'

export default {
    name: 'AddressBook',
    props: {
        adminForm : { type: Boolean, default: true },
        singleValue: { type: Boolean, default: false },
        reset: { type: Number, default: 0 },
        showInternalStructures: { type: Boolean, default: false },
        showExternalStructures: { type: Boolean, default: false },
        showInternalUsers: { type: Boolean, default: false },
        showExternalUsers: { type: Boolean, default: false },
        disableOtherInternalEntitiesAsExternal: { type: Boolean, default: false },
        defaultValue: { type: Array, default: () => [] },
        allowStructureSelect: { type: Boolean, default: true },
        isForSignee: { type: Boolean, default: false },
        excludeSelf: { type: Boolean, default: false },
        hideStructureWithDisableTransfer: { type: Boolean, default: false },
        loadOnlyInScopeInternalStrucutres: { type: Boolean, default: false },
        loadOnlyInScopeInternalUsers: { type: Boolean, default: false },
        selectedStructureUser: null,
        selectedStructureUsersList: null,
	    categoryId: { type: Number, default: 0 },
        isSubscribedEntitiesEnable: { type: Boolean, default: false },
        hideSubscribedCheckbox: { type: Boolean, default: false },
        showStructuresOnlyPerEntity: { type: Boolean, default: false },
        companyId: { type: Number, default: 0 },
    },
    data: () => ({
        items: [],
        all_items: [],
        open: [],
        active: [],
        isOpen: false,
        searchVal: '',
        constants:constants,
        nodeName: '',
        search_items: [],
        openNodes: [],
        newActive: false,
        dropDown: false,
        values: [],
        value: '',
        enableCheckBoxOnStructures: true,
        enableCheckBoxOnUsers: true,
        headers: {},
        selectedNodes: [],
        SearchLabel: '',
        AddDisabled: true,
        selectedIds: [], // Track selected IDs for multiple selection
        selectedId: '', // For single selection
        isInitialLoadComplete: false, // Track if initial load is complete
	    client_version_Id: constants.client_version_Id,
        isSubcribed: false,
        lang: localStorage.getItem('lang') != null && localStorage.getItem('lang') != undefined ? localStorage.getItem('lang') : 'en'
	
    }),
    methods: {
        clearArray: function (item) {
            document.querySelector('.rateRecipe .btns-one-small').click();
        },
        initializeDefaultSelections() {
            this.selectedIds = [];
            this.selectedId = '';
            this.values = [];
            this.value = '';
            if (this.singleValue) {
                if (this.selectedStructureUser) {
                    this.selectedId = this.selectedStructureUser.id ? this.selectedStructureUser.id.toString() : '';
                    this.value = this.selectedStructureUser;
                }
            } else {
                if (this.selectedStructureUsersList && this.selectedStructureUsersList.length > 0) {
                    this.selectedStructureUsersList.forEach(item => {
                        if (item.id) {
                            const itemId = item.id.toString();
                            if (!this.selectedIds.includes(itemId)) {
                                this.selectedIds.push(itemId);
                                this.values.push(item);
                            }
                        }
                    });
                }
            }
        },
        buildChildTree(item) {
            if ((item.isEntityRecipient !== undefined || item.isEntityRecipient !== null || this.adminForm) || (!item.isEntityRecipient || this.adminForm)) {
                return this.getData(item.id, (res) => {
                    item.children = [];
                    res.data.forEach(element => {
                        var newItem = {
                            id: element.userId == null ? element.id.toString() : element.userId + '-' + element.structureId,
                            name: element.name,
                            isUser: element.userId != null,
                            isChild: true,
                            profession: element.profession,
                            childrens: element.childrens,
                            children: [],
                            userId: element.userId,
                            structureId: element.structureId,
                            parentId: element.parentId,
                            isExternal : element.isExternal,
                            disableTransfers : element.disableTransfers,
                            color : element.color
                        };
 
                        this.all_items.push(newItem);
                        item.children.push(newItem);
                    });
 
                    this.restoreSelectionsForItems(item.children);
 
                    if (!this.openNodes.some(x => x == item.id)) {
                        this.openNodes.push(item.id);
                    }
                })
            } else {
                return;
            }
        },
        restoreSelectionsForItems(items) {
            items.forEach(item => {
                if (this.singleValue) {
                    if (this.selectedStructureUser) {
                        if (this.isItemMatch(item, this.selectedStructureUser)) {
                            this.selectedId = item.id;
                            this.value = item;
                        }
                    }
                } else {
                    if (this.selectedStructureUsersList && this.selectedStructureUsersList.length > 0) {
                        this.selectedStructureUsersList.forEach(selectedItem => {
                            if (this.isItemMatch(item, selectedItem)) {
                                if (!this.selectedIds.includes(item.id)) {
                                    this.selectedIds.push(item.id);
                                    if (!this.values.some(v => v.id === item.id)) {
                                        this.values.push(item);
                                    }
                                }
                            }
                        });
                    }
                }
            });
        },
        isItemMatch(item, selectedItem) {
            if (!selectedItem || !selectedItem.id) return false;
           
            const selectedId = selectedItem.id.toString();
            const itemId = item.id.toString();
           
            if (itemId === selectedId) return true;
           
            if (item.isUser && selectedItem.userId && selectedItem.structureId) {
                const userStructureId = selectedItem.userId + '-' + selectedItem.structureId;
                if (itemId === userStructureId) return true;
            }
           
            return false;
        },
        isItemSelected(item) {
            return this.selectedIds.includes(String(item.id));
        },
        isSingleItemSelected(item) {
            return this.selectedId === item.id;
        },
        toggleItemSelection(item, isSelected) {
            if (isSelected) {
                if (!this.selectedIds.includes(item.id)) {
                    this.selectedIds.push(item.id);
                    if (!this.values.some(v => v.id === item.id)) {
                        this.values.push(item);
                    }
                }
            } else {
                const index = this.selectedIds.indexOf(item.id);
                if (index > -1) {
                    this.selectedIds.splice(index, 1);
                    this.values = this.values.filter(v => v.id !== item.id);
                }
            }
        },
        setSingleItemSelection(item, isSelected) {
            if (isSelected) {
                this.selectedId = item.id;
                this.value = item;
            } else {
                this.selectedId = '';
                this.value = '';
            }
        },
        handleSearch(isClear) {
            if (this.searchVal && !isClear) {
                if (this.searchVal.length < 3 && window.SearchValAtLeast4char == true) {
                    window.showAlert('res_Msgs_AtLeast4char', 'warning');
                    return;
                }
            }
 
            this.getData('', (res) => {
                this.lang = localStorage.getItem('lang') != null && localStorage.getItem('lang') != undefined ? localStorage.getItem('lang') : 'en';
                window.hideLoading()
                this.openNodes = [];
                this.all_items = [];

                this.items = res.data;
                this.items.forEach(ele => {
                    ele.id = ele.id.toString();
                    this.all_items.push(ele);
                    this.processItemChildren(ele);
                });
 
                this.restoreSelectionsForItems(this.all_items);
               
                if (!this.isInitialLoadComplete) {
                    this.isInitialLoadComplete = true;
                }
            })
        },
        processItemChildren(ele) {
            ele.isUser = ele.userId != null;
            ele.isChild = true;
           
            if (ele.children && ele.children.length > 0) {
                ele.children.forEach(item => {
                    this.all_items.push(item);
                    this.processItemChildren(item);
                });
                if (this.searchVal) {
                    this.openNodes.push(ele.id);
                }
            }
        },
        clear() {
            this.searchVal = '';
            this.handleSearch(true);
        },
        resetAddressBook() {
	    this.isSubcribed = false;
            this.items = [];
            this.all_items = [];
            this.searchVal = '';
            this.openNodes = [];
            this.isInitialLoadComplete = false;
           
            this.initializeDefaultSelections();
           
            this.handleSearch(true);
        },
        closeAddressBook() {
            this.$emit('closeAddressBook');
        },
        handleSelectFromAddressBook() {
            if (this.singleValue) {
                if (this.value == '') {
                    window.showAlert('res_Msgs_SelectAtLeastOne', 'warning');
                    return;
                }
 
                var foundItem = this.all_items.find(x => x.id == this.value.id);
                if (foundItem != null) {
                    var retVal;
                    if (foundItem.isUser)
                        retVal = {
                            id: foundItem.userId + '-' + foundItem.structureId,
                            name: foundItem.name,
                            isUser: foundItem.isUser,
                            external: foundItem.isExternal,
                            color: foundItem.color,
                            email:foundItem?.email 
                        }
                    else
                        retVal = {
                            id: foundItem.id,
                            name: foundItem.name,
                            isUser: foundItem.isUser,
                            external: foundItem.isExternal,     
                            email:foundItem?.email          
                        }
                       
                    if(this.hideStructureWithDisableTransfer && foundItem.disableTransfers){
                        window.showAlert(this.$t("res_Msg_NotAllowedToSelectThisStructure"), 'error');
                        return;
                    }
                }
 
                var validationRes = this.validateSelection([retVal]);
 
                if (validationRes) {
                    this.$emit('handleSelectFromAddressBook', retVal);
                }
            }
            else {
                if (this.values.length == 0) {
                    window.showAlert('res_Msgs_SelectAtLeastOne', 'warning');
                    return;
                }
 
                var retVal = []
                this.values.forEach(element => {
                    var foundItem = this.all_items.find(x => x.id == element.id);
                    if (foundItem != null) {
                        if (foundItem.isUser)
                            retVal.push({ id: foundItem.userId + '-' + foundItem.structureId, 
                                          name: foundItem.name, isUser: foundItem.isUser, 
                                          external: foundItem.isExternal, isCompany: foundItem.isCompany,
                                          email:foundItem?.email });
                        else{
                            if(!(this.hideStructureWithDisableTransfer && foundItem.disableTransfers)){
                                retVal.push({ id: foundItem.id, name: foundItem.name, 
                                    isUser: foundItem.isUser, external: foundItem.isExternal, 
                                    isCompany: foundItem.isCompany ,
                                    email:foundItem?.email });
                            }
                        }
                    }
                });
 
                var validationRes = this.validateSelection(retVal);
 
                if (validationRes) {
                    this.$emit('handleSelectFromAddressBook', retVal);
                }
            }
        },
        validateSelection(selectedValues) {
            if (!this.allowStructureSelect) {
                if (selectedValues.some((item) => !item.isUser)) {
                    window.showAlert('res_Msgs_StructureIsNotAllowedForSelect', 'warning');
                    return false;
                }
            }
            return true;
        },
        getData(parentId, onSuccess) {
            var params = "?search=" + this.searchVal +
                "&parentId=" + (parentId ? parentId : '') +
                "&showExternal=" + this.showExternalStructures +    
                "&showInternal=" + this.showInternalStructures +
                "&showInternalUsers=" + this.showInternalUsers +
                "&showExternalUsers=" + this.showExternalUsers +
                "&isForSignee=" + this.isForSignee +
                "&excludeSelf=" + this.excludeSelf +
                "&disableOtherInternalEntitiesAsExternal=" + this.disableOtherInternalEntitiesAsExternal +
                "&hideStructureWithDisableTransfer=" + this.hideStructureWithDisableTransfer +
                "&loadOnlyInScopeInternalStrucutres=" + this.loadOnlyInScopeInternalStrucutres +
                "&loadOnlyInScopeInternalUsers=" + this.loadOnlyInScopeInternalUsers +
                "&loadOnlySubcribedStructures=" + this.isSubcribed +
                "&categoryId=" + this.categoryId +
                "&companyId=" + (this.companyId || 0) +
                "&showStructuresOnlyPerEntity=" + this.showStructuresOnlyPerEntity;

            window.showLoading()
            axios.get(constants.baseApiUrl + 'StructureUser/GetStructuresUsers' + params)
                .then(res => {
                    //this.values = [];
                    onSuccess(res);
                })
                .catch(err => console.warn(err))
                .finally(() => window.hideLoading())
        },
        CapitalizeFirstLetter(string) {
            return utils.CapitalizeFirstLetter(string)
        },
        searchFieldKeydownHandler() {
            this.handleSearch(false)
        },
        handleCollapseChildren(openNodes) {
            this.openNodes = openNodes;
        }
    },
    computed: {
        selectedNodeObject() {
        return {
            name: this.defaultValue.name,
            checked: true
        }
    }
    },
    mounted() {
    	if(this.isSubscribedEntitiesEnable) {
            this.isSubcribed = this.isSubscribedEntitiesEnable; }
        this.SearchLabel = window.translate("res_Label_SearchPlaceHolder");
        this.headers = { 'Authorization': 'Bearer ' + sessionStorage.getItem('jwt_token') };
       
        this.initializeDefaultSelections();
       
        this.handleSearch(false);
    },
    watch: {
        selectedIds: {
            handler: function (newVal) {
                this.AddDisabled = newVal.length === 0;
            },
            deep: true
        },
        selectedId: function (newVal) {
            this.AddDisabled = !newVal || newVal === '';
        },
        values: {
            handler: function (newVal) {
                this.AddDisabled = newVal.length === 0;
            },
            deep: true
        },
        value: function (newVal) {
            this.AddDisabled = !newVal || newVal === '';
        },
        reset: function (newVal, oldVal) {
            if (newVal !== oldVal) {
                this.resetAddressBook();
            }
        },
        selectedStructureUser: {
            handler: function (newVal) {
                if (this.singleValue && this.isInitialLoadComplete) {
                    this.initializeDefaultSelections();
                    this.restoreSelectionsForItems(this.all_items);
                }
            },
            deep: true
        },
        selectedStructureUsersList: {
            handler: function (newVal) {
                if (!this.singleValue && this.isInitialLoadComplete) {
                    this.initializeDefaultSelections();
                    this.restoreSelectionsForItems(this.all_items);
                }
            },
            deep: true
        },
	    isSubcribed: function(newVal, oldVal)
        {
            if(!this.isSubscribedEntitiesEnable)
            {
                this.showInternalStructures = false;
                this.showExternalStructures = true;
            }
            
            if(newVal != oldVal && (newVal == true  || newVal == false) && !this.isSubscribedEntitiesEnable)
            {
                this.value = '';
                this.values = [];
                this.items = []

                this.getData('', (res) => 
                {
                    this.lang = localStorage.getItem('lang') != null && localStorage.getItem('lang') != undefined ? localStorage.getItem('lang') : 'en';
                    window.hideLoading()

                    this.items = res.data;
                    this.items.forEach(ele => {
                        ele.id = ele.id.toString();
                        this.all_items.push(ele);
                        this.insertion(ele);
                    });
                })
            }

            this.restoreSelectionsForItems(this.all_items);

    }
}
}
</script>
 
<style>
.v-messages {
    display: none !important;
}
</style>